import makeStyles from '@mui/styles/makeStyles';

const muiInputStyles = makeStyles({
  muiInputs: {
    "& .MuiOutlinedInput-input": {
      color: "var(--alt-black)",
    },
    "& .MuiInputLabel-root": {
      color: "var(--alt-black)",
    },
    "& .MuiSelect-icon": {
      color: "var(--alt-black)",
    },
    "& .MuiSvgIcon-root": {
      color: "var(--alt-black)",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      cursor: "not-allowed",
    },
    "& .MuiInputBase-input.Mui-disabled:hover": {
      color: "var(--alt-black)",
    },
    "& .MuiFormLabel-root": {
      color: "var(--alt-black)",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white",
    },
    "& .MuiOutlinedInput-root.Mui-disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#737373",
    },
    "&:hover .MuiSelect-icon": {
      color: "var(--primary-color)",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "var(--primary-color)",
    },
    "&:hover .MuiInputLabel-root": {
      color: "var(--primary-color)",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primary-color)",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "var(--accent-primary-color)",
      backgroundColor: "white",
    },
    "& .Mui-focused .MuiSelect-icon": {
      color: "var(--accent-primary-color)",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "var(--accent-primary-color)",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--accent-primary-color)",
    },
    "& .MuiFormLabel-asterisk": {
      color: "var(--error-color)",
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "var(--primary-color)",
    },
    "& .MuiIconButton-colorSecondary:hover": {
      color: "var(--primary-color)",
    },
    "& .MuiRadio-root.Mui-focusVisible": { /* MUI radio padding is 9px, so this needs to add up to 9px */
      border: "2px solid var(--accent-primary-color)",
      padding: "3px",
      margin: "4px",
    },
    "& .MuiTypography-body1": { /* MUI radio padding is 9px, so this needs to add up to 9px */
      fontSize: ".95rem",
    },
    "& .Mui-focusVisible":{
      border: "2px solid var(--accent-primary-color)",
    }
  },
});

export default muiInputStyles;